/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const EnterRestrictionDataParser = 
/* #__PURE__ */ parsers.object([
    ['password', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class EnterRestrictionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return EnterRestrictionDataParser.decode(input).map(res => new EnterRestrictionData(res));
    }
    static unsafeDecode(input) {
        return EnterRestrictionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnterRestrictionDataParser.encode(data);
    }
    static schema() {
        return EnterRestrictionDataParser.schema();
    }
}
